import { FileQuestion, RefreshCw } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { EmptyState } from 'src/shared/components/EmptyState'
import { Column } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { paths } from 'src/routes/paths'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const RequestUnavailable = ({
  publicId,
  isMissing,
  onRetry,
  onBack,
}: {
  publicId?: string
  isMissing: boolean
  onRetry: () => void
  onBack?: () => void
}) => {
  const { t } = useLocalization()
  const navigate = useNavigate()
  const requestLabel = publicId ? `#${publicId}` : t('this request', 'denna förfrågan')

  const goBack = () => {
    if (onBack) {
      onBack()
      return
    }
    navigate(paths.myAccount + paths.requests)
  }

  return (
    <Column className="flex flex-1 items-center justify-center p-8">
      <EmptyState
        withCard={false}
        icon={<FileQuestion className="h-5 w-5" />}
        title={
          isMissing
            ? t('Request not found', 'Förfrågan hittades inte')
            : t('Could not load request', 'Kunde inte ladda förfrågan')
        }
        description={
          isMissing
            ? t(
                `We could not find ${requestLabel}. It may have been deleted, or you do not have access.`,
                `Vi kunde inte hitta ${requestLabel}. Den kan ha tagits bort, eller så saknar du behörighet.`
              )
            : t(
                `Something went wrong while loading ${requestLabel}. Check your connection and try again.`,
                `Något gick fel när ${requestLabel} skulle laddas. Kontrollera anslutningen och försök igen.`
              )
        }
        button={
          <Column className="items-center gap-2">
            {!isMissing && (
              <Button variant="secondary" size="sm" onClick={onRetry}>
                <RefreshCw className="h-3.5 w-3.5" />
                {t('Try again', 'Försök igen')}
              </Button>
            )}
            <Button variant="ghost" size="sm" onClick={goBack}>
              {t('Back to requests', 'Tillbaka till förfrågningar')}
            </Button>
          </Column>
        }
      />
    </Column>
  )
}
